<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout row wrap>
        <v-flex xs12>
            <v-btn
                    color="primary"
                    class="new-user-btn"
                    @click="createUser"
            >New User
            </v-btn>
        </v-flex>
        <v-flex xs12>
            <v-data-table
                class="elevation-1"
                :headers="headers"
                :items="users"
                :rows-per-page-items="rowsPerPageItems"
                :loading="usersLoading"
            >
                <template v-slot:items="props">
                    <td>{{ props.item.username }}</td>
                    <td>{{ props.item.roles[0].displayName }}</td>
                    <td>{{ props.item.organization ? props.item.organization.displayName : '' }}</td>
                    <td>{{ props.item.status }}</td>
                    <td justify-center layout px-0>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" small @click="editUser(props.item)" class="mr-2">edit</v-icon>
                            </template>
                            <span>Edit</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" small @click="removeUser(props.item.uuid)" class="mr-2">delete</v-icon>
                            </template>
                            <span>Delete</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" small @click="updateUserStatus(props.item)">{{ props.item.status === 'Active' ? 'lock' : 'lock_open' }}</v-icon>
                            </template>
                            <span>{{ props.item.status === 'Active' ? 'Ban' : 'Unban' }}</span>
                        </v-tooltip>
                    </td>
                </template>
            </v-data-table>
        </v-flex>

        <v-dialog
                v-model="userDialog"
                width="500"
        >
            <v-card>
                <v-card-title
                        class="headline"
                        primary-title
                >
                    Add New User
                </v-card-title>
                <v-card-text>
                    <v-form>
                        <v-container>
                            <v-layout column wrap>
                                <v-flex>
                                    <v-text-field
                                            v-model="user.username"
                                            label="Username"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex v-if="!isEditing">
                                    <v-text-field
                                            v-model="user.password"
                                            label="Password"
                                            type="password"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex>
                                    <v-select
                                            v-model="user.role"
                                            :items="roles"
                                            item-text="displayName"
                                            item-value="uuid"
                                            label="Select Role"
                                    ></v-select>
                                </v-flex>
                                <v-flex>
                                    <v-select
                                            v-model="user.organization"
                                            :items="organizations"
                                            :disabled="!(isSuperAdmin || isBindezAdmin) || isSpecialRoleSelected"
                                            item-text="displayName"
                                            item-value="uuid"
                                            label="Select Organization"
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="error"
                            flat
                            @click="userDialog = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                            color="primary"
                            flat
                            @click="saveUser"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import { mapActions, mapState, mapMutations } from "vuex";
    import md5 from 'js-md5';
    import current_user from '../mixins/current_user';
    import ROLES from "../constants/roles";

    function encryptPassword(raw) {
        return md5(raw);
    }

    export default {
        mixins: [ current_user ],

        data() {
            return {
                user: {
                    username: '',
                    password: '',
                    role: null,
                    organization: null,
                },

                defaultUser: {
                    username: '',
                    password: '',
                    role: null,
                    organization: null,
                },

                headers: [
                    {
                        text: 'Username',
                        value: 'username'
                    },
                    {
                        text: 'Role',
                        value: 'role'
                    },
                    {
                        text: 'Organization',
                        value: 'organization.name'
                    },
                    {
                        text: 'Status',
                        value: 'status'
                    },
                    {
                        text: 'Actions',
                        value: 'username',
                        sortable: false
                    }
                ],

                rowsPerPageItems: [50],

                userDialog: false,
            }
        },

        created() {
            this.loadUsers();
            this.getAllRoles();
        },

        methods: {
            createUser() {
                this.userDialog = true;
                this.user = Object.assign({}, this.defaultUser, 
                    { 
                        organization: !(this.isSuperAdmin || this.isBindezAdmin) 
                            ? this.currentUser.organization.uuid 
                            : null 
                    });
            },

            saveUser() {
                if (!this.isFormValid()) {
                    alert('Must enter every fields!');
                    return;
                }

                if (this.isEditing) {
                    this.updateUser(this.user)
                        .then(() => {
                            this.user = Object.assign({}, this.defaultUser);
                            this.userDialog = false;
                        });
                    this.$ua.trackEvent('UpdateUser', 'click', 
                        `${this.currentUser.username || 'User'} updated ${this.user.uuid} with payload ${JSON.stringify(this.user, null, 2)}`);
                } else {
                    let new_user = Object.assign({}, this.user, 
                        { password: encryptPassword(this.user.password) });

                    this.addUser(new_user)
                        .then(() => {
                            this.user = Object.assign({}, this.defaultUser);
                            this.userDialog = false;
                        });

                    this.$ua.trackEvent('CreateUser', 'click', 
                        `${this.currentUser.username || 'User'} created ${JSON.stringify(this.user, null, 2)}`);
                }
            },

            removeUser(userid) {
                if (confirm('Are you sure to delete this user?')) {
                    this.deleteUser(userid);
                    this.$ua.trackEvent('DeleteUser', 'click', 
                        `${this.currentUser.username || 'User'} deleted ${userid}`);
                }
            },

            isFormValid() {
                const validUsername = this.user.username != null
                    && this.user.username.length > 0

                const validPassword = this.isEditing || 
                    (this.user.password != null && this.user.password.length > 0);

                const validRole = this.user.role != null

                const validOrganization = this.isSpecialRoleSelected || !!this.user.organization;

                return validUsername && validPassword 
                    && validRole && validOrganization;
            },

            loadUsers() {
                this.setUsersLoading(true);
                this.getAllUsers()
                    .finally(() => this.setUsersLoading(false));
            },
            
            ...mapActions('users', [
                'getAllUsers',
                'deleteUser',
                'addUser',
                'updateUser',
                'getAllRoles',
                'updateStatus',
            ]),

            ...mapMutations('users', ['setUsersLoading']),

            ...mapMutations('organizations', ['setOrganizations']),

            editUser(user) {
                this.userDialog = true;
                this.user = Object.assign({}, user, { 
                    role: user.roles[0].uuid,
                    organization: user.organization ? user.organization.uuid : null
                });
            },

            updateUserStatus(user) {
                let changeStatus = user.status === 'Active' ? 'Banned' : 'Active';
                this.updateStatus({ userID: user.uuid, status: changeStatus });
                
                if (changeStatus === 'Active') {
                    this.$ua.trackEvent('UnbanUser', 'click', 
                        `${this.currentUser.username || 'User'} unban user ${user.uuid}, ${user.username}`);
                } else {
                    this.$ua.trackEvent('BanUser', 'click', 
                        `${this.currentUser.username || 'User'} ban user ${user.uuid}, ${user.username}`);
                }
            },
        },

        computed: {
            ...mapState('organizations', ['organizations']),

            ...mapState('users', {
                'users': 'list',
            }),

            ...mapState('users', [ 'usersLoading', 'roles' ]),

            isEditing() {
                return this.user.uuid != null;
            },

            isSpecialRoleSelected() {
                const selectedRole = this.roles.find(role => role.uuid === this.user.role);
                const selectedRoleCode = selectedRole ? selectedRole.code : null;
                return !!selectedRoleCode && ( 
                    selectedRoleCode === ROLES.SUPERADMIN ||
                    selectedRoleCode === ROLES.SCANNING_ADMIN ||
                    selectedRoleCode === ROLES.BINDEZ_ADMIN
                );
            }
        },

        watch: {
            isSpecialRoleSelected(val) {
                if (val) this.user.organization = null;
            }
        }
    }
</script>

<style scoped>
    .new-user-btn {
        margin-left: 0;
        margin-right: 0;
    }
</style>
